import { render, staticRenderFns } from "./ColorBadge.vue?vue&type=template&id=ed70cea6&scoped=true"
import script from "./ColorBadge.vue?vue&type=script&lang=js"
export * from "./ColorBadge.vue?vue&type=script&lang=js"
import style0 from "./ColorBadge.vue?vue&type=style&index=0&id=ed70cea6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed70cea6",
  null
  
)

export default component.exports